import Vue from "vue"
// import Home from "./views/Home.vue"
import Router from "vue-router"
import Login from "./views/Login.vue"
import Account from "./views/Account.vue"
// import DID from "./views/DID.vue"
import PSTN from "./views/PSTN.vue"
import Password from "./views/Password.vue"
import BillingReport from "./views/BillingReport.vue"
import CallHistory from "./views/CallHistory.vue"

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: "Login"
      }
    },
    {
      path: "/",
      name: "Home",
      meta: {
        title: "VOIP Dashboard - Home",
        requiresAuth: true
      },
      redirect() {
        if (router.app.$cnc.authToken) {
          return {
            name: "Account-update",
            params: { accountId: Vue.prototype.$cnc.actor.id }
          }
        } else {
          return {
            name: "Login"
          }
        }
      }
    },
    {
      path: "/account/:accountId",
      name: "Account-update",
      component: Account,
      meta: {
        title: "Account",
        requiresAuth: true
      }
    },
    {
      path: "/account/:accountId/password",
      name: "Password-update",
      component: Password,
      meta: {
        title: "Password Change",
        requiresAuth: true
      }
    },
    {
      path: "/account/:accountId/dids/:didNumberId",
      name: "PSTN-update",
      component: PSTN,
      meta: {
        title: "PSTN Mappings",
        requiresAuth: true
      }
    },
    {
      path: "/billing-report/:accountId?/:search_date?",
      name: "Billing-report",
      component: BillingReport,
      meta: {
        title: "Billing Report",
        requiresAuth: true
      }
    },
    {
      path: "/call-history/:account_id?/:search_date?/:norm_number?",
      name: "Call-history",
      component: CallHistory,
      meta: {
        title: "Call History",
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !router.app.$cnc.authToken) {
    next({ name: "Login" })
  } else if (router.app.$cnc.authToken && to.name === "Login") {
    next({ name: "Home" })
  } else {
    next()
  }

  window.scrollTo(0, 0)
})

router.afterEach(to => {
  document.title = to.meta.title || document.title
})

export default router
